import { render, staticRenderFns } from "./CurationListHistoryLayout.vue?vue&type=template&id=11ddca03&scoped=true&"
import script from "./CurationListHistoryLayout.vue?vue&type=script&lang=js&"
export * from "./CurationListHistoryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ddca03",
  null
  
)

export default component.exports